export function removeInlineStylesFromHtml(htmlString) {
  const template = document.createElement('template');
  template.innerHTML = htmlString;
  template.content.querySelectorAll('[style]').forEach((node) => node.removeAttribute('style'));
  template.content.querySelectorAll('style').forEach((node) => node.remove());
  return template.innerHTML;
}

export function extractTextFromHtml(htmlString) {
  const template = document.createElement('template');
  template.innerHTML = htmlString;
  return template.content.textContent || '';
}
